import { action } from 'satcheljs';
import AttachmentId from 'owa-service/lib/contract/AttachmentId';

export const setIsExpanded = action('setIsExpanded', (composeId: string, isExpanded: boolean) => ({
    isExpanded: isExpanded,
    composeId: composeId,
}));

export const onPillAttached = action(
    'onPillAttached',
    (composeId: string, attachmentId: AttachmentId) => ({
        composeId: composeId,
        attachmentId: attachmentId,
    })
);

export const onAttachFailed = action(
    'onAttachFailed ',
    (composeId: string, attachmentId: AttachmentId) => ({
        composeId: composeId,
        attachmentId: attachmentId,
    })
);

export const onCloseRecentAttachmentPills = action(
    'setCloseRecentAttachmentPills',
    (composeId: string) => ({
        composeId: composeId,
    })
);

export const deleteRecentAttachmentPillsView = action(
    'deleteRecentAttachmentPillsView',
    (composeId: string) => ({
        composeId: composeId,
    })
);

export const onShowExpandButton = action(
    'onShowExpandButton',
    (composeId: string, isOverFlow: boolean) => ({
        isOverFlow: isOverFlow,
        composeId: composeId,
    })
);

export const initializeRecentAttachmentPillsView = action(
    'initializeRecentAttachmentPillsView',
    (
        numberOfRecipients: number,
        recipientName: string,
        composeId: string,
        attachments: AttachmentId[]
    ) => ({
        numberOfRecipients: numberOfRecipients,
        recipientName: recipientName,
        composeId: composeId,
        attachments: attachments,
    })
);

export const onLogShowExpandButton = action('onLogShowExpandButton', (composeId: string) => ({
    composeId: composeId,
}));

// Orchestrators listening

export const onOverflowOneRow = action(
    'onOverflowOneRow',
    (composeId: string, isOverFlow: boolean) => ({
        isOverFlow: isOverFlow,
        composeId: composeId,
    })
);

export const onUpdateRecipients = action(
    'onUpdateRecipients',
    (composeId: string, numberOfRecipients: number, recipientName: string) => ({
        composeId: composeId,
        numberOfRecipients: numberOfRecipients,
        recipientName: recipientName,
    })
);
